export const AI_NOTIFICATION = 'ai_notification_last_date';
export const AI_NOTIFICATION_BANNER_DISMISSED = 'ai_notification_home_page_banner_dismissed';

export const AI_NOTIFICATION_SESSION = 'seen_ai_notification_badge_session';
